import { useState } from 'react';
import { AutomaticModal } from '../../../../../app/modules/apps/automatic-wthdrawal-management/automatic-list/components/automatic-modal/AutomaticModal';
import { SidebarMenuMain } from './SidebarMenuMain';

const SidebarMenu = () => {
	const [isOpenModal, setIsOpenModal] = useState<any | null>(null);

	return (
		<div className='app-sidebar-menu overflow-hidden flex-column-fluid'>
			<div
				id='kt_app_sidebar_menu_wrapper'
				className='app-sidebar-wrapper hover-scroll-overlay-y my-5'
				data-kt-scroll='true'
				data-kt-scroll-activate='true'
				data-kt-scroll-height='auto'
				data-kt-scroll-dependencies='#kt_app_sidebar_logo, #kt_app_sidebar_footer'
				data-kt-scroll-wrappers='#kt_app_sidebar_menu'
				data-kt-scroll-offset='5px'
				data-kt-scroll-save-state='true'
			>
				<div
					className='menu menu-column menu-rounded menu-sub-indention px-3'
					id='#kt_app_sidebar_menu'
					data-kt-menu='true'
					data-kt-menu-expand='false'
				>
					<SidebarMenuMain />
					<div className='mt-4 px-3'>
						<button
							className='btn btn-light-primary fs-7 w-100'
							onClick={() => {
								setIsOpenModal(true);
							}}
						>
							Изменить сумму автовывода
						</button>
					</div>
				</div>
			</div>
			{isOpenModal && (
				<AutomaticModal
					isOpenModal={isOpenModal}
					setIsOpenModal={setIsOpenModal}
				/>
			)}
		</div>
	);
};

export { SidebarMenu };
